export const UPDATE_SETUP = 'UPDATE_SETUP';
export const UPDATE_NOTIFICATIONS = 'UPDATE_NOTIFICATIONS';
export const RESET_INPUT_NOTIFICATIONS = 'RESET_INPUT_NOTIFICATIONS';
export const RESET_SETUP = 'RESET_SETUP';
